import { loadPresentation } from 'presentation/actions';
import {
  type ExtractPayload,
  persistentReducedStream,
  reducer,
} from '@ardoq/rxbeach';

type CurrentOrganizationState = null | {
  label: string;
};

const handleLoadOrganization = (
  _: CurrentOrganizationState,
  { organizationLabel }: ExtractPayload<typeof loadPresentation>
) =>
  organizationLabel
    ? {
        label: organizationLabel,
      }
    : null;

const currentOrganization$ = persistentReducedStream<CurrentOrganizationState>(
  'currentOrganization$',
  null,
  [reducer(loadPresentation, handleLoadOrganization)]
);

export { currentOrganization$ };
